export default __webpack_public_path__ + "static/media/Zoo_10.bd586a90.png";